import { useEffect } from 'react';

import { getEnv } from '@ctct/ctct-helpers';
import { useStripePortal } from '@ctct/state-server-layer';

const returnUrl = `https://app${getEnv()}constantcontact.com/pages/dashboard/home/`;

export const RedirectToStripeOverdueBalancePage = () => {
  const { data: stripePortalDetails } = useStripePortal({ returnUrl });

  const stripePortalUrl = stripePortalDetails?.getPortalUrl();

  useEffect(() => {
    if (stripePortalUrl) {
      window.location.href = stripePortalUrl;
    }
  }, [stripePortalUrl]);

  return null;
};
